import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink, useHistory } from 'react-router-dom';
import { ILoginState, logout } from '@share/store/slices';
import logoLight from '@assets/images/logo/LOGO-2-LIGHT.svg';

import { CARS_SELECTION_TYPE, CONDO_SELECTION_TYPE, CONDOS_SELECTION_TYPE, HOTELS_SELECTION_TYPE, Routes, Urls } from '@share/constants';
import { Spin } from 'antd';
import { isEmpty } from 'lodash';
import { AdminTravBusiness, CoordinatorTravBusiness, HasPermission } from '@utils';
import { getMyReward, getTierBenefits, INotificationBarState, IWalletRewardState, notificationBarActions, setNotification } from '@store/slices';

//import avatar1 from '@assets/images/avatar/avatar01.png';
import avatar1 from '@assets/images/avatar/marker.svg';
import { FormattedMessage, useIntl } from 'react-intl';
import { ModalConfirmation } from '../modal-confirmation';
import { axiosInstanceB2B } from '@share/utils';

const LogInNav = () => {

  const history = useHistory();
  const dispatch = useDispatch();

  const login = useSelector((state: { loginStore: ILoginState }) => state.loginStore);
  const { totalNew, notifications, loading, count,unreadNotifications} = useSelector((state: { notificationBarStore: INotificationBarState }) => state.notificationBarStore);
  const { myReward } = useSelector((state: { walletRewardStore: IWalletRewardState }) => state.walletRewardStore);

  const { account } = login;
  const searchTypes = JSON.parse(account?.searchTypes ?? '[]');
  const isHotels = searchTypes.includes(HOTELS_SELECTION_TYPE);
  const isCars = searchTypes.includes(CARS_SELECTION_TYPE);
  const isCondos = searchTypes.includes(CONDOS_SELECTION_TYPE);
  const headerBackgroundColorPref = account?.headerBackgroundColor;
  const headerLogoPref = account?.logoDB;
  const headerFontColor = account?.headerFontColor;

  const headerBackgroundColor = useMemo(() => (!isEmpty(headerBackgroundColorPref) ? headerBackgroundColorPref : '#ffffff'), [headerBackgroundColorPref]);
  const logo = useMemo(() => (!isEmpty(headerLogoPref) ? headerLogoPref : logoLight), [headerLogoPref]);

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [notificationDropdownOpen, setNotificationDropdownOpen] = useState(false);
  const [notificationId, setNotificationId] = useState<string | null>(null);
  const [imageValid, setImageValid] = useState(false);
  const [accountToDelete, setAccountToDelete] = useState<boolean>(false);
  const [deleteLoading, setDeleteLoading] = useState<boolean>(false);

  const resultsPerPage = 10;
  const currentPage = 1;
  const type = 'unread';

  const handleDelete = async () => {
    try {
      const payload = {
        state : 'Delete'
      }
      await axiosInstanceB2B.post(`/identity/users/${user?.userId}/delete`, payload);

      dispatch(logout());
      history.push(`/${login.account?.name}`);
      setDeleteLoading(false);
      setAccountToDelete(false)
    } catch (error) {
      setDeleteLoading(false);
    }
    }
  const signOut = () => {
    dispatch(logout());
    history.push(`/${login.account?.name}`);
  };

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const toggleNotificationDropdown = async () => {
    try {
      setNotificationDropdownOpen(!notificationDropdownOpen);
    } catch (error) {
      console.error('Failed to fetch locations:', error);
    } finally {
    }
  };

  const handleNavLinkClick = (path: string) => {
    history.push(path);
    setDropdownOpen(false);
  };

  const handleNotificationLinkClick = (path: string) => {
    history.push(path);
    setNotificationDropdownOpen(false);
  };

  const handleNotificationClick = async (notificationId: any) => {
    const url = `/${login.account?.name}${Urls.NotificationList}/${notificationId}`;
    history.push(url);
    setNotificationDropdownOpen(false);    
  }

  const loginStore = useSelector((state: { loginStore: ILoginState }) => state.loginStore);
  const { user } = loginStore;
  const userStorage = loginStore.user;
  const isLogged = !!userStorage;

  const accountName = login.account?.name;

  const ISADMIN = HasPermission(userStorage, AdminTravBusiness);
  const ISCOORDINATOR = HasPermission(userStorage, CoordinatorTravBusiness);

  useEffect(() => {
    dispatch(setNotification(currentPage, resultsPerPage, user?.userId, type));
  }, [currentPage]);
  
  useEffect(() => {
    dispatch(notificationBarActions.setCount(0));
    const url = window.location.pathname;
    const parts = url.split('/');
    const id = parts[parts.length - 1]; 
      if (id) {
        setNotificationId(id);
      }
  },[notificationDropdownOpen]);

  useEffect(() => {
    handleImage();
  }, [login?.user?.userAdditionalData?.profilePhoto]);

  const handleImage = async () => {
    var image = new Image();
    image.onload = () => setImageValid(true)
    image.onerror = () => setImageValid(false)
    image.src = login?.user?.userAdditionalData?.profilePhoto || '';
  };

    useEffect(() => {
      dispatch(getMyReward(loginStore.user?.userId || ''));
      dispatch(getTierBenefits(loginStore.user?.userId || ''));
    }, [])
  
  const intl = useIntl();
  return (
    <header
      className="navbar-light header-sticky"
      style={{ backgroundColor: headerBackgroundColor }}
    >
      <nav className="navbar navbar-expand-xl">
        <div className="container">
          <div className="navbar-brand">
            <img
              className="light-mode-item navbar-brand-item logo-pointer logo-mobile"
              src={logo}
              width={166}
              height={40}
              alt="logo"
              onClick={() => history.push(`/${login.account?.name}${isLogged && isHotels ? '/dashboard' : '/cars'}`)}
            />
            <img
              className="dark-mode-item navbar-brand-item logo-pointer logo-mobile"
              src={logo}
              alt="logo"
              width={166}
              height={40}
              onClick={() => history.push(`/${login.account?.name}${isLogged && isHotels ? '/dashboard' : 'cars'}`)}
            />
          </div>

          <div className="navbar-collapse collapse" id="navbarCollapse">
            <ul className="navbar-nav navbar-nav-scroll me-auto">
              {isHotels && (
                <li className="nav-item dropdown">
                  <a
                    style={{ color: headerFontColor }}
                    className="nav-link dropdown-toggle"
                    href="#"
                    id="listingMenu"
                    data-bs-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <FormattedMessage id="hotels" />
                  </a>
                  <ul className="dropdown-menu menu-v2" aria-labelledby="listingMenu">
                    <li>
                      <button
                        className="dropdown-item"
                        onClick={() => history.push(`/${accountName}/dashboard`)}
                        style={{ color: headerFontColor }}
                      >
                      <FormattedMessage id="dashboard.individual.title" />
                      </button>
                    </li>
                  </ul>
                </li>)}

              {isCars && (
                <li className="nav-item">
                  <NavLink
                    to={`/${accountName}${Routes.CarsDashboard}`}
                    className="nav-link"
                    style={{ color: headerFontColor }}
                  >
                  <FormattedMessage id="Cars" />
                  </NavLink>
                </li>)}
              {isCondos && (
                <li className="nav-item">
                  <NavLink
                    to={`/${accountName}${Routes.CondoSearch}`}
                    className="nav-link"
                    style={{ color: headerFontColor }}
                  >
                  <FormattedMessage id="condos.title" />
                  </NavLink>
                </li>)}

              {(ISADMIN || ISCOORDINATOR) && (
                <li className="nav-item dropdown">
                  <a
                    className="nav-link dropdown-toggle"
                    id="pagesMenu"
                    data-bs-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    style={{ color: headerFontColor }}
                  >
                    <FormattedMessage id="dashboard.company.title" />
                  </a>
                  <ul className="dropdown-menu menu-v2" aria-labelledby="pagesMenu">
                    <li>
                      <button
                        className="dropdown-item"
                        onClick={() => history.push(`/${accountName}/company-trends`)}
                        style={{ color: headerFontColor }}
                      >
                        <FormattedMessage id="dashboard.company.settings" />
                      </button>
                    </li>
                    <li>
                      <button
                        className="dropdown-item"
                        onClick={() => history.push(`/${accountName}/company-team`)}
                        style={{ color: headerFontColor }}
                      >
                        <FormattedMessage id="dashboard.team.members" />
                      </button>
                    </li>
                    <li>
                      <button
                        className="dropdown-item"
                        onClick={() => history.push(`/${accountName}/account-payment`)}
                        style={{ color: headerFontColor }}
                      >
                        <FormattedMessage id="dashboard.billing.payments" values={{ value: '&' }} />
                      </button>
                    </li>
                  </ul>
                </li>)}
            </ul>
          </div>
          {login?.userWalletData ? (
            <div className="navbar-collapse collapse" id="navbarCategoryCollapse">
              <ul className="navbar-nav navbar-nav-scroll nav-pills-primary-soft text-center ms-auto p-2 p-xl-0">
                <li className="nav-item">
                  <NavLink
                    to={`/${login?.account?.name}/account-rewards`}
                    className="nav-link active"
                    style={{ color: headerFontColor }}
                  >
                    <i className="bi bi-trophy me-2"></i><FormattedMessage id="dashboard.rewards" /> {login.userWalletData?.balance ? login.userWalletData.balance?.toFixed(2) : 0} pts
                  </NavLink>
                </li>
              </ul>
            </div>
          ) : <Spin spinning={loading} className="mx-5 d-xl-block d-none" />}
          <ul className="nav flex-row align-items-center list-unstyled ms-xl-auto">
            <button
              className="navbar-toggler ms-auto ms-sm-0 p-0 p-sm-2 me-3"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarCollapse"
              aria-controls="navbarCollapse"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-animation">
                <span></span>
                <span></span>
                <span></span>
              </span>
            </button>

            {(ISADMIN || ISCOORDINATOR) &&
              (
                <li className="nav-item dropdown ms-0 ms-md-3">
                  <a
                    className="nav-notification btn btn-light p-0 mb-0 mt-0"
                    href="#"
                    onClick={toggleNotificationDropdown}
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    data-bs-auto-close="outside"
                    id="notificationDropdown"
                  >
                    <i className="bi bi-bell fa-fw"></i>
                  </a>

                  {!!totalNew && 
                    <span className="notif-badge animation-blink"></span>}

                  <div
                    className={`dropdown-menu dropdown-animation dropdown-menu-end dropdown-menu-size-md shadow-lg ${notificationDropdownOpen ? 'show' : ''
                      } menu-v2`}
                  >
                    <div className="card bg-transparent">
                      <div className="card-header bg-transparent d-flex justify-content-between align-items-center border-bottom">
                        <h6 className="m-0">
                          <FormattedMessage id="dashboard.notifications" />
                          <span className="badge bg-danger bg-opacity-10 text-danger ms-2">{`${count > 0 ? totalNew - count : totalNew}`} <FormattedMessage id="add.new" /></span>
                        </h6>
                      </div>


                      <div className="card-body p-0">
                        {loading ? (
                          <div className="loading-widget-container text-center">
                            <Spin spinning={loading}></Spin>
                          </div>
                        ) : (
                          <ul className="list-group list-group-flush list-unstyled p-2">
                            {unreadNotifications?.items
                              ?.filter((item: any) => {
                                const isUnread = item.status !== 1;
                                const isNotCurrent = !notificationId || item.id !== notificationId;
                                return isUnread && isNotCurrent;
                              })
                              .slice(-2)
                              .map((item: any, index: number) => (
                                <li key={index}>
                                  <span
                                    className="pointer list-group-item list-group-item-action rounded border-0 mb-1 p-3"
                                    style={{ overflow: 'hidden', maxWidth: '316px' }}
                                    onClick={() => handleNotificationClick(item?.id)}
                                  >
                                    <h6
                                      className="mb-2"
                                      style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                                    >
                                      {item.title}
                                    </h6>
                                    <p
                                      className="mb-0 small"
                                      style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                                    >
                                      {item.description}
                                    </p>
                                  </span>
                                </li>
                              ))}
                              {((notifications?.items?.length === 0 || unreadNotifications?.items?.length === 0) && !loading) && (
                                <p style={{ marginBottom: '0px', fontSize: '16px', paddingLeft: '10px' }}>No notifications</p>
                              )}
                          </ul>
                        )}
                      </div>

                      <div className="card-footer bg-transparent text-center border-top">
                        <span
                          className="btn btn-sm btn-link mb-0 p-0"
                          onClick={() => handleNotificationLinkClick(`/${accountName}/notifications-list`)}
                        >
                          <FormattedMessage id="dashboard.notification.view.all" />
                        </span>
                      </div>
                    </div>
                  </div>
                </li>
              )}

            <li className="nav-item ms-3 dropdown">
              <a
                className="avatar avatar-sm p-0"
                onClick={toggleDropdown}
                href="#"
                id="profileDropdown"
                role="button"
                data-bs-auto-close="outside"
                data-bs-display="static"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <img
                  className="avatar-img rounded-1"
                  src={!imageValid ? avatar1 : login?.user?.userAdditionalData?.profilePhoto}
                  // src={`${!imageValid ? avatar1 : login?.user?.userAdditionalData?.profilePhoto}?${new Date().getTime()}`}
                  alt=""
                />
              </a>

              <ul
                className={`dropdown-menu dropdown-animation dropdown-menu-end shadow pt-3 ${dropdownOpen ? 'show' : ''} menu-v2`}
                aria-labelledby="profileDropdown"
              >
                <li className="px-3 mb-3">
                  <div className="d-flex align-items-center">
                    <div className="avatar me-3">
                      <img
                        className="avatar-img rounded-circle shadow"
                        src={!imageValid ? avatar1 : login?.user?.userAdditionalData?.profilePhoto}
                        // src={`${!imageValid ? avatar1 : login?.user?.userAdditionalData?.profilePhoto}?${new Date().getTime()}`}
                        alt=""
                      />
                    </div>
                    <div>
                      <NavLink
                        to={`/${login?.account?.name}/account-settings`}
                        className="h6 mt-2 mt-sm-0 capitalize"
                      >
                        {login?.user?.firstName}
                      </NavLink>
                      <p className="small m-0"><FormattedMessage id="dashboard.account.owner" /></p>
                    </div>
                  </div>
                </li>

                {
                  (ISADMIN || ISCOORDINATOR) &&
                  (
                    <>
                      <li>
                        <hr className="dropdown-divider" />
                      </li>
                      <li>
                        <button
                          className="dropdown-item capitalize"
                          onClick={() => handleNavLinkClick(`/${login?.account?.name}/company-settings`)}
                        >
                          {login?.account?.name}
                        </button>
                      </li>
                      <li>
                        <hr className="dropdown-divider" />
                      </li>
                    </>

                  )
                }

                <li>
                  <button
                    className="dropdown-item "
                    onClick={() => handleNavLinkClick(`/${accountName}/personal-information`)}
                  >
                    <i className="bi bi-gear fa-fw me-2"></i> <FormattedMessage id="dashboard.account.settings" />
                  </button>
                </li>
                <li>
                  <button
                    className="dropdown-item"
                    onClick={() => handleNavLinkClick(`/${accountName}/bookings`)}
                  >
                    <i className="bi bi-suitcase-lg fa-fw me-2"></i>
                    <FormattedMessage id="dashboard.account.my.bookings" />
                  </button>
                </li>
                <li>
                  <button
                    className="dropdown-item "
                    onClick={() => handleNavLinkClick(`/${accountName}/account-rewards`)}
                  >
                    <i className="bi bi-trophy fa-fw me-2"></i><FormattedMessage id="dashboard.account.my.rewards" />
                  </button>
                </li>
                {/* <li>
                  <button
                    className="dropdown-item "
                    onClick={() => handleNavLinkClick(`/${accountName}/account-credit`)}
                  >
                    <i className="bi bi-coin fa-fw me-2"></i>My Trip Credits
                  </button>
                </li> */}
                <li>
                  <button
                    className="dropdown-item "
                    onClick={() => handleNavLinkClick(`/${accountName}/account-saved`)}
                  >
                    <i className="bi bi-bookmark-check fa-fw me-2"></i><FormattedMessage id="dashboard.account.saved.properties" />
                  </button>
                </li>
                <li>
                  <button
                    className="dropdown-item "
                    onClick={() => setAccountToDelete(true)}
                  >
                    <i className="bi bi-person-x fa-fw me-2"></i><FormattedMessage id="delete.my.account" />
                  </button>
                </li>
                <li>
                  <hr className="dropdown-divider" />
                </li>
                <li>
                  <button className="dropdown-item bg-danger-soft-hover" onClick={signOut}>
                    <i className="bi bi-power fa-fw me-2"></i><FormattedMessage id="dashboard.account.logout" />
                  </button>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </nav>
      <ModalConfirmation
          message={`${intl.formatMessage({ id: 'delete.account.message' })}`}
          title={`${intl.formatMessage({ id: 'delete.account' })}`}
          yesMessage="yes"
          noMessage="no"
          visible={accountToDelete}
          onCancel={() => setAccountToDelete(false)}
          onConfirm={handleDelete}
        />
    </header>
  );
};

export default LogInNav;
